define.alias("shared/components/shared/pre-boarding/context-modal/side-plan-card", "settings/components/shared/pre-boarding/context-modal/side-plan-card");